import { z } from 'zod'

export const FormSectionPresentationSchema = z.object({
  /**
   * `question-list` renders boolean fields as an explicit, numbered Yes/No
   * question list; questions start at No. `long-text` renders text fields as
   * full-width, auto-growing multi-line inputs.
   */
  variant: z.enum(['question-list', 'long-text']),
})

export const FormSectionSchema = z
  .object({
    id: z.string(),
    type: z.literal('form').default('form'),
    title: z.string().optional(),
    fields: z.array(z.string()),
    /** Completion requires all fields when omitted, none for [], or only the listed fields. */
    requiredFields: z.array(z.string()).optional(),
    presentation: FormSectionPresentationSchema.optional(),
    /** Enables AI autofill; gong-agent-service interprets the contents from workflow config. */
    agent: z.record(z.string(), z.unknown()).optional(),
    /** Gecko Internal users also have access regardless of this permission list. */
    agentPermissions: z.array(z.string()).optional(),
  })
  .refine(
    ({ fields, requiredFields }) =>
      requiredFields?.every((field) => fields.includes(field)) ?? true,
    {
      path: ['requiredFields'],
      message: 'Required fields must be included in the section fields',
    }
  )

export type FormSection = z.infer<typeof FormSectionSchema>
